<template>
  <v-app>
    <v-content>
      <v-container fluid class="d-flex justify-center">
        <slot />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {}
</script>
